import { render, staticRenderFns } from "./LawMatterCourtExpertList.vue?vue&type=template&id=6725cf1d&"
import script from "./LawMatterCourtExpertList.vue?vue&type=script&lang=js&"
export * from "./LawMatterCourtExpertList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterCourtExpertList.vue?vue&type=style&index=0&id=6725cf1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports